import { MultiSelect } from "@mantine/core"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { base64StringToFile, toBase64 } from "../../utils/base64.js"
import { countryCodes } from "../../utils/countryCodes.js"
import { IPv4Regex, IPv6Regex } from "../../utils/ipRegex.js"
import DropZone from "./Dropzone"

const COUNTRY_CODES = Object.keys(countryCodes)

const CountryBlockerSettings = ({
	onSaveSettings,
	countriesBlocked,
	blockedPageImg,
	ipWhitelist,
}) => {
	const [t] = useTranslation()
	const [countriesBlockedSelected, setCountriesBlockedSelected] = useState(
		countriesBlocked || [],
	)
	const [selectedBlockedPageImg, setSelectedBlockedPageImg] = useState(
		base64StringToFile(blockedPageImg, "img.jpeg"),
	)
	const [ipWhitelistSelected, setIpWhitelistSelected] = useState(
		ipWhitelist || [],
	)
	const [ipError, setIpError] = useState(null)

	const saveSettings = async () => {
		let base64Img = ""
		if (selectedBlockedPageImg) {
			base64Img = await toBase64(selectedBlockedPageImg)
		}
		onSaveSettings({
			countriesBlocked: countriesBlockedSelected,
			blockedPageImg: base64Img,
			ipWhitelist: ipWhitelistSelected,
		})
	}

	const addIp = (ipAddress) => {
		if (!IPv4Regex.test(ipAddress) && !IPv6Regex.test(ipAddress)) {
			setIpError(
				"Incorrect IP address format. Enter a valid IPv4 or IPv6 address.",
			)
		} else if (ipWhitelistSelected.includes(ipAddress)) {
			setIpError("That IP address is already in the whitelist.")
		} else {
			setIpError(null)
			setIpWhitelistSelected([...ipWhitelistSelected, ipAddress])
		}
	}

	const addCurrentIp = () => {
		fetch("/api/protect/getCountryFromIP")
			.then((res) => res.json())
			.then((json) => {
				if (json.ipAddress) {
					addIp(json.ipAddress)
				}
			})
			.catch((err) => {
				console.error(err)
			})
	}

	return (
		<div style={{ padding: "2rem" }}>
			<p style={{ marginBottom: "0.5rem", fontWeight: "600" }}>
				{t("protect.block_countries.title")}
			</p>

			<MultiSelect
				placeholder={t("protect.block_countries.placeholder")}
				data={COUNTRY_CODES.map((country, i) => {
					return { label: countryCodes[country], value: `${country}` }
				})}
				onChange={(change) => setCountriesBlockedSelected(change)}
				value={countriesBlockedSelected}
				radius="lg"
				searchable
			/>

			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					marginTop: "2rem",
					marginBottom: "0.5rem",
				}}
			>
				<p style={{ fontWeight: "600" }}>
					{t("protect.block_countries.image_displayed")}
				</p>
				{(blockedPageImg || selectedBlockedPageImg) && (
					<div
						style={{
							textDecoration: "underline",
							marginLeft: "auto",
							cursor: "pointer",
							width: "fit-content",
							fontSize: "0.8rem",
							fontWeight: "600",
						}}
						onClick={() => setSelectedBlockedPageImg(null)}
					>
						{t("protect.block_countries.remove_image")}
					</div>
				)}
			</div>

			<DropZone
				blockedPageImg={selectedBlockedPageImg}
				setBlockedPageImg={setSelectedBlockedPageImg}
			/>

			<div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						marginTop: "2rem",
						marginBottom: "0.5rem",
					}}
				>
					<p style={{ fontWeight: "600" }}>
						{t("protect.block_countries.ip_whitelisting")}
					</p>
					<p
						style={{
							fontWeight: "600",
							cursor: "pointer",
							textDecoration: "underline",
							fontSize: "0.8rem",
						}}
						onClick={addCurrentIp}
					>
						{t("protect.block_countries.add_my_current_ip")}
					</p>
				</div>

				<MultiSelect
					placeholder={t(
						"protect.block_countries.start_typing_the_ip",
					)}
					data={ipWhitelistSelected}
					value={ipWhitelistSelected}
					creatable
					searchable
					onChange={(change) => setIpWhitelistSelected(change)}
					onCreate={(e) => addIp(e)}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							addIp(e.target.value)
						}
					}}
					getCreateLabel={(query) => `+ Add ${query}`}
					radius="lg"
					error={ipError}
				/>
			</div>

			<button
				className="neu-background shadow neu-button"
				style={{
					padding: "0.6rem 1.2rem",
					marginLeft: "auto",
					marginTop: "3rem",
				}}
				onClick={saveSettings}
			>
				<span style={{ fontWeight: "600" }}>{t("common.save")}</span>
			</button>
		</div>
	)
}

export default CountryBlockerSettings
